import { ErrorHandler, Injectable } from "@angular/core";
import { PosthogService } from "./posthog.service";
import { environment } from "@env";
@Injectable({
	providedIn: "root",
})
export class GlobalErrorHandlerService implements ErrorHandler {
	constructor(private posthog: PosthogService) {}

	handleError(error: Error): void {
		console.error("Global error caught:", error);
		if (!environment.ENABLE_MONITORING) {
			return;
		}
		this.posthog.captureError(error, {
			source: "global_error_handler",
			url: window.location.href,
			userAgent: navigator.userAgent,
		});
	}
}
